import "../components/css/otp.css";
import "react-toastify/dist/ReactToastify.css";
import React, { useState, useEffect, useRef } from "react";
import OtpInput from "react-otp-input";
import ddpi from "../image/ddpi-banner3.svg";
import randomkey from "../config/randomfunc.mjs";
import { useNavigate } from "react-router-dom";
import clientapifunc from "../service/clientapi.mjs";
import otpapifunc from "../service/otpapi.mjs";
import { Slide, ToastContainer, toast } from "react-toastify";
import mainurl from "../config/mainurl.mjs";
import secureLocalStorage from "react-secure-storage";

function Otp(props) {
  let otpmsg = {};
  const inputRef = useRef(null);

  // STATE AND VARIABLES
  //==========================

  const Navigate = useNavigate();

  let otpinterval;

  const Clientrec = props.clientnumsend;
  const [uniqueidrec, setuniqueidrec] = useState(props.clientIdsend);

  const [Loader, setLoader] = useState();
  const [Otptime, setOtptime] = useState(30);
  const [otp, setOtp] = useState("");

  // FUNCTIONS
  //=======================

  window.onpopstate = (e) => {
    secureLocalStorage.clear();
    Navigate('/')
  }

  function timestart() {
    setOtptime(Otptime - 1);
  }

  async function resendapi() {
    setOtp("");
    var newkey = randomkey();
    clientapifunc(Clientrec, newkey);
    setuniqueidrec(newkey);
  }

  function ResendOtp() {
    if (Otptime == 0) {
      resendapi();
      setOtptime(30);
    }
  }

  function otpbtn() {
    if (otp.length < 6) {
      toast.warn("Please Enter OTP", {
        toastId: "success1",
      });
    }
    otpapicall();
  }

  async function otpapicall() {
    async function getFlags() {
      var dataflag = {};
      var raw = JSON.stringify({
        cc: Clientrec,
      });

      var requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": "Basic RERQSS1BRlNMLUxJVkUtVjE6YXdlciQlY3MzNDVkXnp4dHkyNkAjZmdocVNEKmFa" },
        body: raw,
        redirect: "follow",
      };

      await fetch(`${mainurl}/flags`, requestOptions)
        .then((response) => response.text())
        .then((result) => {
          Object.assign(dataflag, JSON.parse(result));
        })
        .catch((error) =>
        // console.log("error", error)
        { }
        );
      return dataflag;
    }
    otpmsg = await otpapifunc(Clientrec, uniqueidrec, otp);
    if (otpmsg.message == "OTP Expired") {
      toast.warn("Otp Expired", {
        style: {
          fontSize: "14px",
        },
        toastId: "success1",
      });
      setOtp("");
    }
    if (otpmsg.message == "wrong details") {
      toast.error("Invalid OTP", {
        style: {
          fontSize: "14px",
        },
        toastId: "success1",
      });
      setOtp("");
    }
    if (otpmsg.message == "OTP Verified") {
      setLoader(true);
      toast.success(`OTP Verified`, {
        style: {
          fontSize: "14px",
        },
        toastId: "success1",
      });
      secureLocalStorage.setItem("CC", Clientrec);
      secureLocalStorage.setItem("uid", uniqueidrec);
      const userflags = await getFlags(Clientrec);
      console.log(userflags,'dataFlag')
      secureLocalStorage.setItem("status", `${uniqueidrec}oc`);
      if (userflags.rejectflag === 1) {
        setTimeout(() => {
          Navigate("/preview");
        }, 2000);
      } else if ((userflags.pay_in === 0 || userflags.margin_pledge === 0 || userflags.mutual_fund === 0 || userflags.buyback === 0) && userflags.stampflag === 0 && userflags.esignflag === 0 && userflags.approveflag === 0) {
        setTimeout(() => {
          Navigate("/preview");
        }, 2000);
      }
      else if ((userflags.pay_in === 1 && userflags.margin_pledge === 1 && userflags.mutual_fund === 1 && userflags.buyback === 1) && userflags.stampflag === 0 && userflags.esignflag === 0 && userflags.approveflag === 0) {
        secureLocalStorage.setItem("status", `${uniqueidrec}pStatus`);
        setTimeout(() => {
          Navigate("/estampform");
        }, 2000);
      } else if ((userflags.pay_in === 1 && userflags.margin_pledge === 1 && userflags.mutual_fund === 1 && userflags.buyback === 1) && userflags.stampflag === 1 && userflags.esignflag === 0 && userflags.approveflag === 0) {
        secureLocalStorage.setItem("status", `${uniqueidrec}esfc`);
        setTimeout(() => {
          Navigate("/esign");
        }, 2000);
      } else if ((userflags.pay_in === 1 && userflags.margin_pledge === 1 && userflags.mutual_fund === 1 && userflags.buyback === 1) && userflags.stampflag === 1 && userflags.esignflag === 1 && userflags.approveflag === 0) {
        secureLocalStorage.setItem("status", `${uniqueidrec}finish`);
        setTimeout(() => {
          Navigate("/complete");
        }, 2000);
      } else if ((userflags.pay_in === 1 && userflags.margin_pledge === 1 && userflags.mutual_fund === 1 && userflags.buyback === 1) && userflags.stampflag === 1 && userflags.esignflag === 1 && userflags.approveflag === 1) {
        secureLocalStorage.setItem("status", `${uniqueidrec}approved`);
        setTimeout(() => {
          Navigate("/approved");
        }, 2000);
      } else {
        setTimeout(() => {
          Navigate("/preview");
        }, 2000);
      }
    }
  }

  // EFFECT
  // ============

  useEffect(() => {
    otpinterval = setInterval(timestart, 1000);
    if (Otptime == 0) {
      clearInterval(otpinterval);
    }
    return () => {
      clearInterval(otpinterval);
    };
  }, [Otptime]);

  useEffect(() => {
    if (otp.length === 6) {
      otpapicall();
    }
  }, [otp]);
  useEffect(() => {
    if (Clientrec.length == 0) {
      Navigate("/");
    }
  }, []);

  return (
    <>
      <div className="container">
        <div className="otp-container">
          <div className="upper-column">
            <h1 className="main-heading">Verify OTP</h1>
            <div className="loginimg">
              <img src={ddpi} alt="ddpi"></img>
            </div>
            <p className="para mb-5 sm:mb-10">
              OTP Sent to registered Mobile & Email ID
            </p>

            <div className="otp-inputbox">
              <OtpInput
                inputStyle={{
                  width: "",
                  font: "2rem",
                  borderBottom: "1px solid #fb8f36",
                }}
                inputType="number"
                value={otp}
                shouldAutoFocus={otp.length === 0}
                onChange={(value) => {
                  setOtp(value);
                }}
                caretHidden={otp.length === 0}
                numInputs={6}
                renderSeparator={<span>&nbsp;</span>}
                renderInput={(props) => <input {...props} />}
                ref={inputRef}
              />
              <ToastContainer
                position="top-right"
                autoClose={2500}
                transition={Slide}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
              <p className="hide">Otp Does't Match Try Again</p>
              <p className="small-text">
                Didn't receive the OTP ? &nbsp;
                <span>
                  <a
                    className="link-text resend-otp cursor-pointer"
                    onClick={() => ResendOtp()}
                  >
                    {Otptime > 0
                      ? ` 00: ${Otptime < 10 ? `0${Otptime}` : Otptime}`
                      : `Resend OTP`}
                  </a>
                </span>
              </p>
            </div>
          </div>

          <div className="button-box">
            {Loader === true ? (
              <svg
                class="checkmark"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 52 52"
              >
                <circle
                  class="checkmark__circle"
                  cx="26"
                  cy="26"
                  r="25"
                  fill="none"
                />
                <path
                  class="checkmark__check"
                  fill="none"
                  d="M14.1 27.2l7.1 7.2 16.7-16.8"
                />
              </svg>
            ) : (
              <button className="active-btn" onClick={() => otpbtn()}>
                Verify OTP
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
export default Otp;
